import axios, { AxiosResponse } from 'axios'
import { ClienteDtoColaborador, ColaboradorList } from './_models'
import { ID } from '../../../../../../_metronic/helpers'
import { ClienteView } from '../../empresasCliente-list/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const EMPRESAS_CLIENTE_COLABORADOR_URL = `${API_URL}/empresas/cliente/colaborador`

/**
 * Busca todos os colaboradores do cliente da empresa
 * @param idCliente Identificador da empresa cliente
 * @returns ColaboradorList[]
 */
export const getColaboradoresOfEmpresaCliente = (idCliente: ID) => {
  return axios
    .get(`${EMPRESAS_CLIENTE_COLABORADOR_URL}/${idCliente}`)
    .then((response: AxiosResponse<ColaboradorList[] | undefined>) => response.data)
}

/**
 * Cadastra um colaborador do cliente da empresa
 * @param idCliente Identificador do cliente
 * @param coordenador Objeto ClienteDtoColaborador
 * @returns ClienteView
 */
export const createCoordenador = (
  idCliente: ID,
  coordenador: ClienteDtoColaborador
): Promise<ClienteView> => {
  return axios
    .post(`${EMPRESAS_CLIENTE_COLABORADOR_URL}/${idCliente}`, coordenador)
    .then((resp: AxiosResponse<ClienteView>) => resp.data)
}

/**
 * Altera um colaborador do cliente da empresa
 * @param idCliente Identificador do cliente
 * @param coordenador Objeto ClienteDtoColaborador
 * @returns ClienteView
 */
export const updateCoordernador = (
  idCliente: ID,
  coordenador: ClienteDtoColaborador
): Promise<ClienteView> => {
  return axios
    .put(`${EMPRESAS_CLIENTE_COLABORADOR_URL}/${idCliente}`, coordenador)
    .then((resp: AxiosResponse<ClienteView>) => resp.data)
}

/**
 * Remove um colaborador do cliente da empresa
 * @param idEmpresaCliente Identificador da empresa cliente
 * @param idCoordenador Identificador do coordenador
 * @returns ClienteView
 */
export const deleteColaboradorCliente = (idEmpresaCliente: ID, idCoordenador: ID) => {
  return axios.delete(`${EMPRESAS_CLIENTE_COLABORADOR_URL}/${idEmpresaCliente}`, {
    data: {
      id: idCoordenador,
    },
  })
}
